/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Stack, Heading, Text } from '@towersystems/towersystems-design-system';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import Navigation from 'modules/dashboard/connections/navigation';
import { requestConnection } from 'state/connections/actions';
import LoadingPlaceholder from 'modules/dashboard/connections/loading-placeholder';
import Card from 'components/card';

const Tools = ({ connectionId, ...props }) => {
    const [requesting, setRequesting] = useState(true);
    const [connection, setConnection] = useState(null);

    useEffect(() => {
        loadData(connectionId);
    }, []);

    const loadData = async (connectionId) => {
        setRequesting(true);
        try {
            let connections = await props.requestConnection(connectionId);
        } catch (error) {
            console.log(error);
            page('/');
        }
        setRequesting(false);
    };

    if (true === requesting) {
        return <LoadingPlaceholder connectionId={connectionId} section='tools' />;
    }

    return (
        <Main>
            <Navigation connectionId={connectionId} section='tools' />
            <Stack space='medium'>
                <Box display='flex' justifyContent='spaceBetween' alignItems='center' paddingBottom='xlarge'>
                    <Heading level='1'>Tools</Heading>
                </Box>
            </Stack>
        </Main>
    );
};

export default connect((state, ownProps) => ({}), {
    requestConnection
})(Tools);
